import React from 'react';
import DocumentTitle from 'react-document-title';
import CountBtn from './countBtn';
import IconTan from '../../static/images/icon-tan.png';
import clientApi from '../../api/client';
import Toast from '../../utils/toast';
import { apiCancel, apiDefine } from '../../api/web';
import './style.less';
import AXIOS from '../../api/axios';
import { parseQuery } from '../../utils/tools';

const acTips = [
    "已购课程、钻石、成就等信息",
    "个人资料及订单信息",
    "学习记录、上课记录等相关信息",
]
const pdTips = [
    "已购课程、奖杯、熊猫币等信息",
    "个人资料及订单信息",
    "学习记录、上课记录等相关信息",
]
export default class Logoff extends React.PureComponent {
    constructor(props){
        super(props);
        const queryObj = parseQuery(props.location.search.slice(1));
        this.state = {
            step: 0, // 0 注销提示页面 1 注销发送验证码
            active: true,
            codeText: '获取验证码',
            smsCode: "",
            appType: queryObj.apptype,
            tips: queryObj.apptype === 'ac' ? acTips : pdTips
        }
        const data = clientApi.getClientDataSync({ data: ['phone'] }) || '{"phone": "00110011099"}';
        console.log(data, '===');
        this.clientData = JSON.parse(data);
    }
    componentDidMount() {
        apiDefine({apiName: 'alertViewBack', fn: this.alertViewBack });
    }
    componentWillUnmount() {
        apiCancel('alertViewBack');
    }
    handleSubmit = () => {
        const { step, appType } = this.state;
        let params = {
            content: '你是真的想要狠心的注销账号呢？还是仅仅要退出APP？',
            confirm: '退出APP',
            cancel: '注销账号',
            id: 'H5_1002'
        }
        if (step === 1) {
            params = {
                content: appType === 'ac' ? '确定要注销吗？注销后你的账号信息会被系统自动清除，且账号无法再次在爱课AirCourse使用' : '确定要注销么？注销后您的账号信息会被系统自动清除，且账号无法再次在爱课精品小班使用',
                confirm: '确认注销',
                cancel: '再想想',
                id: 'H5_1002'
            }
        }
        clientApi.alertView(params);
        // 本地模拟客户端回调
        // this.alertViewBack(JSON.stringify({select: 'cancel', id: 'H5_1002'}));
    }
    alertViewBack = (str) => {
        const data = JSON.parse(str);
        const { select, id } = data;
        const { step } = this.state;
        if (id === 'H5_1002') {
            if (select === 'confirm') {
                if (step === 0) {
                    // 选择退出APP
                    clientApi.toClientLogin()
                }
                if (step === 1) {
                    // 注销账号 - 确认注销
                    this.handleWriteOff()
                }
            }
            if (select === 'cancel') {
                if (step === 0) {
                    // 选择注销账号
                    this.setState({ step: 1, active: false });
                }
            }
        }
    }
    timeEnd = () => {
        this.setState({ codeText: '获取验证码'});
    }
    timeStart = () => {
        this.setState({ codeText: ''});
        const { phone } = this.clientData;
        const { appType } = this.state
        if (appType === 'ac') {
            AXIOS.smsCode({data: {phone, type: 1}}, this.timeStartCallBack)
        } else {
            AXIOS.smsCodePd({data: {phone, type: 2, signType: 1}}, this.timeStartCallBack)
        }
    }
    timeStartCallBack = (res, err) => {
        if (err)  {
            Toast.info({text: err.errorMessage})
            this.setState({ codeText: '获取验证码'});
            this.refs.countBtn.clearTimer()
        } else {
            Toast.info({text: '验证码已发送'})
        }
    }
    codeChange = e => {
        const { active } = this.state;
        const { value } = e.target;
        if (value && !/^\d+$/.test(value)) return
        this.value = value.trim();
        this.setState({ smsCode: value })
        if (this.value && this.value.length === 6) {
            !active && this.setState({ active: true });
        } else {
            active && this.setState({ active: false });
        }
    }
    handleWriteOff = () => {
        const { phone } = this.clientData;
        const { smsCode, appType } = this.state
        if (appType === 'ac') {
            AXIOS.writeOff({data: {phone, smsCode}}, this.handleWriteOffCallback)
        } else {
            AXIOS.writeOffPd({data: {phone, smsCode}}, this.handleWriteOffCallback)
        }
    }
    handleWriteOffCallback = (res, err) => {
        if(err) Toast.info({text: err.errorMessage})
        else {
            clientApi.toClientLogin()
        }
    }
    render() {
        const { step, active, codeText, smsCode, tips } = this.state;
        const { phone } = this.clientData;
        return <DocumentTitle title="账号注销">
        <div className="account-logoff">
            <div style={{maxWidth: '375px', margin: '0 auto'}}>
                {step === 0 ?
                    <React.Fragment>
                        <img className="icon" src={IconTan} alt="" />
                        <p className="con-1 mt20 mb40 center">注销后以下账号信息将被清空且无法找回</p>
                        <div style={{width: '230px', margin: '0 auto'}}>
                            {
                                tips.map(item => {
                                    return  <p className="con-2" key={item}><span>{item}</span></p>
                                })
                            }
                        </div>
                        <p className="con-3">为了防止您重要的学习记录丢失，请谨慎操作</p>
                    </React.Fragment>
                    : <div style={{padding: '60px 36px 100px 36px'}}>
                        <p className="con-4">账号：{phone}</p>
                        <div className="input-box">
                            <input maxLength={6} type="tel" className="input-code" placeholder="请输入验证码" value={smsCode} onChange={this.codeChange} />
                            <div className="code-btn"><CountBtn type="code" ref="countBtn" num={60} onEnd={this.timeEnd} onStart={this.timeStart} isActive>{codeText}</CountBtn></div>
                        </div>
                        <p className="con-1 mt74 mb20">为了防止您重要的学习记录丢失，请认真阅读以下内容：</p>
                        <p className="con-5"><span>如果您在注销后，您的账号信息会被系统自动清除</span></p>
                        <p className="con-5"><span>注销后账号信息将会无法恢复，请您谨慎操作</span></p>
                    </div>
                }
                <CountBtn onClick={this.handleSubmit} isActive={active} num={30}>{step === 0 ? '继续注销' : '确认注销'}</CountBtn>
            </div>
        </div>
    </DocumentTitle>
    }
}


// WEBPACK FOOTER //
// ./src/components/account/logoff.jsx